import Modal from './index.vue';

export default Modal;
